<template>
<div class="ui items">
  <div class="item">
    <div v-if="imageUrl" class="ui mini image">
      <img :src="imageUrl">
    </div>
    <div class="top aligned content">
      <div class="meta">Curated by</div>
      <div class="header">
        <a>{{curator}}</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'card-meta',
  props: ['curator', 'date'],
  computed: {
    imageUrl() {
      return this.curator ? `src/assets/${ this.curator.toLowerCase() }.jpg` : null
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/CardMeta.vue